import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Sparkles, Facebook, Instagram, Twitter } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link
              to="/"
              onClick={scrollToTop}
              className="flex items-center gap-2 mb-6"
              data-testid="footer-logo"
            >
              <div className="w-10 h-10 rounded-xl bg-sky-600 flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold">Nova Shelf</span>
            </Link>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Professional house cleaning services in Houston, TX. We bring cleanliness and comfort to your home.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-sky-600 transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-sky-600 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-sky-600 transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="footer-link" data-testid="footer-service-standard">
                  Standard Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link" data-testid="footer-service-deep">
                  Deep Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link" data-testid="footer-service-movein">
                  Move-In / Move-Out Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="footer-link" data-testid="footer-service-recurring">
                  Recurring Cleaning
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" onClick={scrollToTop} className="footer-link" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" onClick={scrollToTop} className="footer-link" data-testid="footer-terms">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" onClick={scrollToTop} className="footer-link" data-testid="footer-refund">
                  Refund Policy
                </Link>
              </li>
              <li>
                <a href="#contact" className="footer-link" data-testid="footer-contact">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-sky-400 mt-0.5 flex-shrink-0" />
                <div>
                  <a
                    href="tel:+18884532345"
                    className="text-white hover:text-sky-400 transition-colors font-medium"
                    data-testid="footer-phone"
                  >
                    +1-888-453-2345
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-sky-400 mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:support@novashelf.store"
                  className="text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  support@novashelf.store
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-sky-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400" data-testid="footer-address">
                  1587 Magnolia Court<br />
                  Houston, TX 77002
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-sky-400 mt-0.5 flex-shrink-0" />
                <div className="text-slate-400" data-testid="footer-hours">
                  <p>Mon-Fri: 7:00 AM - 6:00 PM</p>
                  <p>Sat: 8:00 AM - 4:00 PM</p>
                  <p>Sun: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm" data-testid="footer-copyright">
            &copy; {currentYear} Nova Shelf. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Professional House Cleaning Services in Houston, TX
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
